export { default as MetaData } from './MetaData';
